import React from 'react';

import { ModalContainer } from '../../components/ModalContainer';
import { ModifyAppointmentConfirmationView } from './ModifyAppointmentConfirmationView';

import styles from './index.module.css';

interface ModifyAppointmentModalProps {
  title: string;
  instructions: string;
  isOpen: boolean;
  setModalOpen: (val: boolean) => void;
  onModifyAppointment?: () => void;
  pending?: boolean;
}

export const ModifyAppointmentModal: React.FC<ModifyAppointmentModalProps> = ({
  title,
  isOpen,
  instructions,
  setModalOpen,
  onModifyAppointment,
  pending,
}) => {
  return (
    <ModalContainer
      containerClassName={styles.ModalContainer}
      contentClassName={styles.ModalContent}
      isOpen={isOpen}
      onModalClose={() => setModalOpen(false)}
      topLabel={title}
      component={
        <ModifyAppointmentConfirmationView
          instructions={instructions}
          onClose={() => setModalOpen(false)}
          onModifyAppointment={onModifyAppointment}
          pending={pending}
        />
      }
    />
  );
};
